/*
 * @Author: luting
 * @Date: 2022-04-08 15:14:30
 * @lastEditors: luting
 * @LastEditTime: 2023-07-24 11:15:20
 */
import { defineMessages } from 'react-intl';

const messageObject: any = {
  groupTip: '分区会对选中的磁盘进行格式化处理，确认开始分区？',
  consider: '再考虑一下',
  beginToPartition: '开始分区',
  changeDiskSet: '调整磁盘',
  formatting: '格式化,重新分区',
  cancel: '取消',
  extension: '扩展',
  exit: '退出',
  judgeTotalSize: '磁盘容量超过可用容量',
  partitionSuccess: '扩展成功',
  doing: '正在处理中...',
  selectDisk: '请选择磁盘!',
  selectVginfo: '请选择卷组!',

  repartition: '分区失败',
  repartitionSuccess: '分区成功',
  repartitionNonstandard: '分区失败，请先还原再重新创建挂载点',
  multipleChoices: '可多选',
  cannotFindDisk: '未找到可添加的磁盘,请确认',

  node: '卷组名',
  undistributed: '未分配',
  mountPoint: '挂载点',
  capacity: '容量',
  used: '已使用',
  operate: '操作',
  advice: '建议',

  status: '状态',
  unUse: '未使用',

  nextStep: '下一步',
  refersh: '刷新',
  lastStep: '上一步',
  installNow: '确认完成',
  createSystemMountPoint: '创建挂载点',

  confirmDisk: '卷组已建立，请确认磁盘配置',
  partitioningBlock: '正在建立分区...',
  createDiskBlock: '正在创建系统挂载点...',
  chooseWillUseDisk: '请选择磁盘,建立卷组',
  cannotLessen: '磁盘配置完成后,不能缩减磁盘容量',
  resetSize: '重新分区',
  createTip: '当前磁盘配置不可用，请参考安装文档进行调整',
  selectDiskMinLmit: '安装supOS至少需要400GB空间，请扩充磁盘',
  tipText: '磁盘不支持缩小',
  inNewVolumeGroup: '在新卷组创建环境',
  inExistingVolumeGroup: '在已有卷组创建环境',
  leftSize: '可用空间：',
  totalSize: '总空间：',
  sizeTip: ' ( 可用空间至少400GB ) ',
  usableSizeTip: '选择的卷组无可用空间',
  diskSpaceTip: '磁盘空间不足，可能引发supOS不能正常运行',
};

export default defineMessages(messageObject);
